/**
 * Generate VideoObject JSON-LD structured data
 * 
 * This function generates VideoObject schema markup from heroSectionV2 blocks in pageBuilder.
 */

interface PageBuilderBlock {
  type?: string
  typeHandle?: string
  [key: string]: any
}

/**
 * Generate VideoObject JSON-LD structured data from pageBuilder blocks
 * Currently returns a static object, will be generated dynamically from heroSectionV2 block
 */
export function generateVideoObjectFromHeroSection2(pageBuilder: PageBuilderBlock[] = []): {
  '@context': string
  '@type': string
  name: string
  description: string
  thumbnailUrl: string[]
  embedUrl: string
  publisher: {
    '@type': string
    name: string
    logo: {
      '@type': string
      url: string
    }
  }
  transcript: string
} | null {

  // Find block with typeHandle === 'heroSectionV2'
  const heroSectionV2Block = pageBuilder.find(block => block?.typeHandle === 'heroSectionV2')

  // Return null if videoUrl is not filled
  if (!heroSectionV2Block?.['videoUrl']?.['url']) {
    return null
  }

  const transcript = heroSectionV2Block['heading']['html']
    .replace(/<[^>]*>?/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 1000)


  return {
    "@context": "https://schema.org",
    "@type": "VideoObject",
    "name": heroSectionV2Block['subheading'],
    "description": transcript,
    "thumbnailUrl": [(heroSectionV2Block['previewImageDesktop'] || [])[0]['url']],
    "embedUrl": heroSectionV2Block['videoUrl']['url'],
    "publisher": {
      "@type": "Organization",
      "name": "Delight.ai",
      "logo": {
        "@type": "ImageObject",
        "url": "https://sendbird.imgix.net/cms/logo.svg"
      }
    },
    transcript
  }
}

